import { useEffect } from "react";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

export const LegalLayout = ({ title, lastUpdated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="grain-overlay bg-[#080C16] min-h-screen text-white flex flex-col">
      <Navigation />

      {/* Content */}
      <main className="flex-1 w-full max-w-3xl mx-auto px-6 pt-32 pb-16 lg:pt-40 lg:pb-24">
        <div className="flex flex-col gap-3 mb-12">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#00DC82]">
            Legal
          </span>
          <h1
            data-testid="legal-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-white leading-[1.1]"
          >
            {title}
          </h1>
          {lastUpdated && (
            <p className="text-sm text-slate-500">Last updated: {lastUpdated}</p>
          )}
        </div>

        <div className="flex flex-col gap-8">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

// Clearly-labelled placeholder block for approved legal copy (supplied later).
export const LegalPlaceholder = ({ section }) => (
  <div className="rounded-2xl border border-dashed border-white/15 bg-white/[0.02] p-8 flex flex-col gap-3">
    <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[#00DC82]">
      Content area
    </span>
    <p className="text-base font-medium text-white">
      {section} content will be inserted here.
    </p>
    <p className="text-sm text-slate-400 leading-relaxed">
      This is a temporary placeholder. The final approved {section.toLowerCase()} text
      will be supplied separately and dropped into this area without changing the page
      layout.
    </p>
  </div>
);
